<template>
    <div>
        <breadcrumb :routerList="[{to:'/guanhuai',title:'用户交互'},{title:'日清提报详情'}]"/>
        <div class="h-content">
            <div class="h-row h-mrt0">
                <div class="h-rowIn">
					<!-- <div class="h-rowBox" style="margin-bottom: 30px;">
					    <div class="h-rowCon">
					        <div class="h-pieceIn2">
					            <div class="h-pieceTitle2" style="margin-bottom:0.3rem">
					                <h1>日期信息</h1>
					            </div>
					            <div style="width:100%;height:1px;background:#dee1eb;margin-bottom:20px;"></div>
					            <div class="weekplans ljjriqi">
					                <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">
					                    <el-form-item label="时间范围" style="width:40%">
					                        <el-date-picker
											  v-model="formInline.times"
											  type="date"
											  :picker-options="pickerOptions0"
											  placeholder="选择日期">
											</el-date-picker>
					                    </el-form-item>
					                </el-form>
					            </div>
					        </div>
					    </div>
					</div> -->
                    <div class="h-rowBox">
                        <div class="h-rowCon">
                            <div class="h-pieceIn2">
                                <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                    <h1>交互记录</h1>
                                </div>
                                <div class="h-pieceCon2" style="padding:0">
                                    <el-table
                                            ref="multipleTable"
                                            :data="execution"
                                            :border="true"
                                            stripe
											border
                                            style="width: 100%"
                                    >
                                        <el-table-column
                                                type="index"
                                                width="40"
                                                label="#">
                                        </el-table-column>
                                        <el-table-column
                                                width="120"
                                                prop="lianqun"
                                                label="链群">
                                            <template scope="scope">
                                                <brselectlazy category="gh_lianqun" v-model="scope.row.lianqun"
                                                              :v="scope.row.lianqun">
                                                </brselectlazy>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                width="160"
                                                prop="cdate"
                                                label="拜访时间"
                                                :show-overflow-tooltip="true">
                                        </el-table-column>
                                        <el-table-column
                                                prop="euName"
                                                label="用户/客户名称"
                                                :show-overflow-tooltip="true">
												<template slot-scope="scope">
													<div style="text-align: left;">
														{{scope.row.euName}}
													</div>
												</template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="planRemark"
                                                label="拜访目标"
                                                :show-overflow-tooltip="true">
												<template slot-scope="scope">
													<div style="text-align: left;">
														{{scope.row.planRemark}}
													</div>
												</template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="result"
                                                label="实际工作效果"
                                                :show-overflow-tooltip="true">
                                        </el-table-column>
                                        <el-table-column
                                                prop="contact"
                                                label="联系人"
                                                width="80"
                                                :show-overflow-tooltip="true">
                                        </el-table-column>
                                        <el-table-column
                                                prop="contactDept"
                                                label="科室"
                                                width="80"
                                                :show-overflow-tooltip="true">
                                        </el-table-column>
                                        <el-table-column
                                                prop="contactPhone"
                                                label="联系方式"
                                                width="120"
                                                :show-overflow-tooltip="true">
                                        </el-table-column>
                                    </el-table>
                                </div>
                                <div style="width:100%;height:1px;background:#dee1eb;margin:50px 0;"></div>
                                <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                    <h1>明日计划</h1>
                                </div>
                                <div class="h-pieceCon2" style="padding:0">
                                    <el-table
                                            ref="multipleTable"
                                            :data="plan"
                                            stripe
											border
                                            style="width: 100%"
                                    >
                                        <el-table-column
                                                type="index"
                                                width="40"
                                                label="#">
                                        </el-table-column>
                                        <el-table-column
                                                prop="euName"
                                                label="用户/客户名称"
                                                :show-overflow-tooltip="true">
												<template slot-scope="scope">
													<div style="text-align: left;">
														{{scope.row.euName}}
													</div>
												</template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="planTimeStart"
                                                label="开始日期"
												width="100"
                                                :show-overflow-tooltip="true">
                                            <template scope="scope">
                                                {{scope.row.planTimeStart.substr(0,10)}}
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="planTimeEnd"
                                                label="结束日期"
												width="100"
                                                :show-overflow-tooltip="true">
                                            <template scope="scope">
                                                {{scope.row.planTimeEnd.substr(0,10)}}
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="planRemark"
                                                label="拜访目标"
                                                :show-overflow-tooltip="true">
												<template slot-scope="scope">
													<div style="text-align: left;">
														{{scope.row.planRemark}}
													</div>
												</template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="contact"
												width="80"
                                                label="联系人">
                                        </el-table-column>
                                        <el-table-column
                                                prop="contactPhone"
												width="120"
                                                :show-overflow-tooltip="true"
                                                label="联系电话">
                                        </el-table-column>
                                        <el-table-column
												width="80"
                                                label="操作">
                                            <template slot-scope="scope">
                                                <el-button
                                                        type="text"
                                                        size="small"
                                                        class="h-tableLink h-btn" @click="editorplan(scope.row.id)">
                                                    修改
                                                </el-button>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                                <div style="width:100%;height:1px;background:#dee1eb;margin:50px 0;"></div>
                                <div style="width:100%;height:1px;background:#dee1eb;margin:50px 0;"></div>
                                <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                    <h1>资源需求</h1>
                                </div>
                                <div class="h-pieceCon2" style="padding:0">
                                    <el-table
                                            ref="multipleTable"
                                            :data="source"
                                            stripe
											border
                                            style="width: 100%"
                                    >
                                        <el-table-column
                                                type="index"
                                                width="40"
                                                label="#">
                                        </el-table-column>
                                        <el-table-column
                                                width="120"
                                                prop="lianqun"
                                                label="链群">
                                            <template scope="scope">
                                                <brselectlazy category="gh_lianqun" v-model="scope.row.lianqun" :v="scope.row.lianqun"></brselectlazy>
                                            </template>
                                        </el-table-column>
                                            <el-table-column
                                                    prop="content"
                                                    label="内容详细描述"
                                                    :show-overflow-tooltip="true">
													<template slot-scope="scope">
														<div style="text-align: left;">
															{{scope.row.content}}
														</div>
													</template>
                                            </el-table-column>
                                            <el-table-column
                                                    prop="nameList"
													width="110"
                                                    label="指定答复人">
                                            </el-table-column>
                                        <el-table-column
                                                prop="endDate"
                                                label="指定答复日期"
												width="160"
                                                :show-overflow-tooltip="true">
                                        </el-table-column>

                                    </el-table>
                                </div>
                                <div style="width:100%;height:1px;background:#dee1eb;margin:50px 0;"></div>
                                <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                    <h1>其他问题</h1>
                                </div>
                                <div class="h-pieceCon2 textresize" style="padding:0">
                                    <!-- <el-form>
                                        <el-form-item prop="textarea" :rules="[{ required: true, message: '请输入内容', trigger: 'blur'},]"> -->
                                    <el-input
                                            type="textarea"
                                            placeholder="请输入内容"
                                            v-model="textarea"
                                            maxlength="500"
                                            show-word-limit

                                    >
                                    </el-input>
                                    <!-- </el-form-item>
                                    </el-form> -->
                                </div>
                                <!-- <div style="width:100%;height:1px;background:#dee1eb;margin:50px 0;"></div> -->
                                <div class="pinfen">
                                    <!-- 该日请的系统评分为：<span style="color:#087ae7;font-size:30px;font-weight:bold;">A级</span> -->
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="h-txtCenter h-mrt60" style="margin-bottom:20px;">
                        <el-button class="h-btn h-bBtn h-bgwhite" @click="cancelRq">返回</el-button>
                        <!-- <el-button class="h-btn h-bBtn h-bgblueQ2">修改评分</el-button> -->
                        <el-button class="h-btn h-bBtn h-bgblueQ2" @click="submitRq">提交</el-button>
                    </div>
                    <el-dialog :close-on-click-modal="false" title="计划修改" :visible.sync="dialogFormVisible2" class="h-dialog">
                        <div style="margin-top:10px;font-size:16px;color:#f23522;text-align:center;">
                            温馨提示：修改后本次交互计划将转为未达成状态，请慎重选择。
                        </div>
                        <div class="h-formLine">
                            <el-form :model="formLabelAlign3" label-position="right"
                                     ref="formLabelAlign3" :inline="true"
                                     class="demo-ruleForm h-formbLine h-dialogForm">
                                <el-form-item label="客户类型" class="h-elformWrap-1" prop="euType">
                                    <el-select v-model="formLabelAlign3.euType" placeholder="请选择"
                                               @change="customerType">
                                        <el-option v-for="(item) in options2"
                                                   :key="item.code"
                                                   :label="item.name"
                                                   :value="item.code">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="拜访客户" class="h-elformWrap-1" prop="euCode">
                                    <el-select v-model="formLabelAlign3.euName" :v="formLabelAlign3.euName" filterable
                                               remote  :remote-method="showFormList" @change="showForm" placeholder="请输入">
                                        <el-option v-for="(item) in EuName"
                                                   :key="item.usercode"
                                                   :label="item.userName"
                                                   :value="item.userName">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="拜访时间" class="h-elformWrap-1">
					<span class="h-fl">
					  <el-date-picker :clearable="false" @change="beginDate(formLabelAlign3)"
                                      v-model="formLabelAlign3.planTimeStart" value-format="yyyy-MM-dd HH:mm:ss"
                                      type="datetime" placeholder="选择时间" style="width: 100%;"></el-date-picker>
					</span>
                                    <el-col class="line h-txtCenter" :span="2">至</el-col>
                                    <span class="h-fl">
					  <el-date-picker :clearable="false" @change="processDate(formLabelAlign3)"
                                      v-model="formLabelAlign3.planTimeEnd" value-format="yyyy-MM-dd HH:mm:ss"
                                      type="datetime" placeholder="选择时间" style="width: 100%;"></el-date-picker>
					</span>
                                </el-form-item>
                            </el-form>
                            <div class="h-formPiece">
                                <el-form :model="formLabelAlign3" label-position="right"
                                         ref="formLabelAlign3" :inline="true"
                                         class="demo-ruleForm h-formbLine h-dialogForm">
                                    <el-form-item label="部门/科室" class="h-elformWrap-1">
                                        <el-input placeholder="根据客户自动带出"
                                                  v-model="formLabelAlign3.contactDept"></el-input>
                                    </el-form-item>
                                    <el-form-item label="关键人" class="h-elformWrap-1">
                                        <el-input placeholder="根据客户自动带出" v-model="formLabelAlign3.contact"></el-input>

                                    </el-form-item>
                                    <el-form-item label="联系方式" class="h-elformWrap-1" prop="contactPhone">
                                        <el-input placeholder="根据客户自动带出"
                                                  v-model.number="formLabelAlign3.contactPhone"></el-input>

                                    </el-form-item>
                                    <el-form-item label="洽谈内容" prop="planRemark" class="h-elformWrap-1">
                                        <el-input placeholder="请输入" v-model="formLabelAlign3.planRemark"></el-input>
                                    </el-form-item>
                                </el-form>
                            </div>
                        </div>
                        <div slot="footer" class="dialog-footer">
                            <el-button class="h-btn h-formBtn h-bgwhite" @click="dialogFormVisible2 = false">取 消
                            </el-button>
                            <el-button class="h-btn h-formBtn h-bgblueQ2" @click="submitReasonOrChange(2)">确认修改
                            </el-button>
                        </div>
                    </el-dialog>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import ss from '../../api/SystemService';

    export default {
        data() {
            return {
                formLabelAlign3: {},
                //修改计划
                dialogFormVisible2: false,
                textarea: '',
                q: {},
                execution: [],
                source: [],
                product: [],
                plan: [],
                options2:[],
                EuName:[],
				formInline:{
					times:''
				},
				pickerOptions0: {
					disabledDate(time) {
						return time.getTime() < Date.now() - 48 * 60 * 60 * 1000 || time.getTime() > Date.now() - 8.64e6;
					}
				},
            }
        },
        methods: {
            submitReasonOrChange(v){
                //过期未执行提报原因
                let msg="确认修改计划？";
                var subflag=true;
                if(v==1){
                    msg="确认提报原因？";
                    if(!this.formLabelAlign3.remark){
                        this.$msg.msge("请填写提报原因");
                        this.$refs['formLabelAlign3'].validate((valid) => {
                            return valid;
                        })
                        subflag=false;
                    }
                    this.formLabelAlign3.planStatus=4;//提交
                }else{
                    //修改计划
                    this.formLabelAlign3.planStatus=2;//提交
                }
                if(subflag){
                    this.$msg.confirm(msg,()=>{
                        ss.UserCare.updateById(this.formLabelAlign3).then(rd => {
                            this.query();
                            this.$msg.msgs("提交成功");
                            this.dialogFormVisible1=false;
                            this.dialogFormVisible2=false;
                        })
                    })
                }
            },
            processDate(v) {
                if (v.planTimeStart) {//如果有出厂日期
                    //如果购买日期小于出厂日期
                    if(v.planTimeEnd<v.planTimeStart){
                        this.$msg.msge("结束日期不能小于开始日期");
                        v.planTimeEnd="";
                    }
                }
            },
            //时间限制
            beginDate(v){
                if (v.planTimeEnd) {  //如果结束时间不为空，则小于结束时间
                    if(v.planTimeEnd<v.planTimeStart){
                        this.$msg.msge("结束日期不能小于开始日期");
                        v.planTimeStart="";
                    }
                }
            },
            //下拉框选中事件
            showForm(v){
                let obj = {};
                obj = this.EuName.find((item)=>{//这里的userList就是上面遍历的数据源
                    return item.userName === v;//筛选出匹配数据
                });
                this.formLabelAlign3.euCode=obj.userCode;//我这边的name就是对应label的
                this.formLabelAlign3.contactDept=obj.department?obj.department:'';
                this.formLabelAlign3.contact=obj.contactuserName?obj.contactuserName:'';
                this.formLabelAlign3.contactPhone=obj.telephone?obj.telephone:'';
            },
            //通过用户名带出详细信息
            showFormList(value) {
                this.formLabelAlign3.userName = value;
                if (this.formLabelAlign3.euType == 1) {
                    ss.UserCare.agentOption(this.formLabelAlign3).then(rd => {
                        this.EuName = rd;
                    })
                } else if (this.formLabelAlign3.euType == 2) {
                    ss.UserCare.customerOption(this.formLabelAlign3).then(rd => {
                        this.EuName = rd;
                    })
                }
            },
            customerType(v){
                this.formLabelAlign3.euCode=null;
                this.formLabelAlign3.euName=null;
                this.formLabelAlign3.channelCode=null;
                this.formLabelAlign3.areaCode=null;
                this.formLabelAlign3.contactDept=null;
                this.formLabelAlign3.contact=null;
                this.formLabelAlign3.contactPhone=null;
                this.EuName=null;
            },
            //修改计划
            editorplan(item) {
                this.dialogFormVisible2 = true;
                ss.UserCare.planDetail({id: item}).then(rd => {
                    this.formLabelAlign3 = rd.plan;
                })
            },
            //查询当天所有跑动记录/转化需求/转化产品记录
            query() {
                //查看详情
                if (this.$route.query.rqId) {
                    this.q.summaryId = this.$route.query.rqId;
                }

                ss.UserCare.queryExecution(this.q).then(rd => {
                    console.log(rd.todayMap, "下面表格11111111111111");
                    this.execution = rd.todayMap.execution;
                    this.source = rd.todayMap.source;
                    this.product = rd.todayMap.product;
                    this.plan = rd.todayMap.plan;
                    if (rd.todayMap.summary) {
                        this.q = rd.todayMap.summary;
                    }
                    this.textarea = rd.todayMap.summary ? rd.todayMap.summary.notes : '';
                })
            },
            //大类修改时，当块数据proProduct[i]-v,index-i
            // selectProductBig() {
            //     ss.ProService.product1Select().then(rd => {
            //         console.log("产品大类下拉", rd)
            //         this.optionsProductBig = rd;
            //     })
            // },
            // //海尔内部竞品，大类修改时，查询小类列表 v.type大类id-v,index-i
            // selectProductHaier(v) {
            //     ss.ProService.product2Select(v).then(rd => {
            //         this.optionsProductSmail = rd;
            //     })
            // },
            cancelRq() {
                // this.$router.push("/riqing");
				this.$router.go(-1);
            },
            submitRq() {
                if (this.textarea) {
                    this.q.careTotal = this.execution.length;
                    this.q.resTotal = this.source.length;
                    this.q.orderTotal = this.product.length;
                    this.q.notes = this.textarea;
                    if (!this.$route.query.rqId) {
                        this.q.careWeek = this.$util.riQi3(new Date());
                    }
                    this.q.executionList = this.execution;
                    this.q.demandList = this.source;
                    this.q.productList = this.product;
                    this.q.planList = this.plan;
                    console.log("哈哈哈哈啊哈哈", this.q);
                    this.$msg.confirm("确认提交日清?提交审核后将不能再更改。", () => {
                        ss.UserCare.headline({}).then(rd => {
							if (rd.planHead.rqId) {
								this.$msg.msgs("日清只能提交一次，请您不要重复提交！");
								this.$router.go(-1);
							}else{
								this.checkriqing()
							}
						})
                    })
                } else {
                    this.$msg.msge("其他问题不能为空！");
                }

            },
			checkriqing(){
				ss.UserCare.submitSummary(this.q).then(rd => {
				    console.log(rd, "下面表格======");
				    this.$msg.msgs("提交成功！");
				    this.$router.go(-1);
				})
			}
        },
        mounted() {
            this.query();
        },
        created(){
            this.options2 = this.$store.getters.dicts["userCareType"];
        },
    }
</script>
<style>
    .textresize .el-textarea .el-textarea__inner {
        resize: none;
        height: 150px;
    }
	.ljjriqi .h-formBorder .el-input__inner{
		border-left: 0;
		border-right: 0;
		border-top: 0;
	}
</style>
<style scoped>
    .pinfen {
        color: #656565;
        font-size: 16px;
        margin-left: 20px;
    }
</style>
